<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-slot:filter_condition_options>
            <MonitorOptionSet 
                :option_set="option_set"
                @filter_data="filter_data" 
            />
        </template>
	
        <template v-slot:data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :show_download_pdf_btn="true"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template v-slot:table_description>
                    <span> 說明："--"標示，顯示該欄位無資料。</span>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { TABLE_VALUE_TEXT_MAPPING } from "@/config/monitor_config.js"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import MonitorOptionSet from "../monitor_option_set.vue"
    import QpeDatatable from "../qpe_datatable.vue"

	export default {
        name: 'mileage_rainfall_daily',
        
        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            MonitorOptionSet, 
            QpeDatatable
        },
        
        mixins: [monitor_mixin],
        
        data() {
			return {
                header: [],
                table_data: [],
                default_value: 130,
                error_text: '',

                // filter使用
                immutable_table_data: [],
                option_set: [],
                display_all_route: '全區',
            }
        },

        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            }
        },
        
        watch: {
            immutable_table_data:function() {
                if (this.immutable_table_data) {
                    this.init_option_set()
                    this.update_option_set_from_local_storage()
                }
            },
        },

        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

		methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data;
                this.table_data = data;
                this.header = header;
            },

            init_option_set() {  
                let option_set_array = [
                    {current_option_value: this.display_all_route, json_key:'國道名稱', label: 'route'},
                ]

                option_set_array.forEach(item => {
                    if(!item.option_array || item.option_array.length == 1) {
                        item.option_array = this.table_data.map(item2 => {
                            return item2[item.json_key]
                        });
                        item.option_array = [item.current_option_value, ...new Set(item.option_array)]
                    }
                })
                this.option_set = option_set_array
            },
            
            filter_data(filtered_cond) {
                if (this.option_set[0].current_option_value != filtered_cond['route']) {
                    this.option_set[0].current_option_value = filtered_cond['route']
                }
                
                let compare_route
                filtered_cond['route'] === this.display_all_route ? compare_route = '' : compare_route = filtered_cond['route']
        
                let filtered_data = this.immutable_table_data.filter(item => {
                    return (
                        item['國道名稱'].includes(compare_route)
                    )
                })
                this.table_data = filtered_data

                // 把目前選擇的 option 存起來
                localStorage.setItem('mileage_rainfall_daily_option', JSON.stringify(filtered_cond))
            },

            update_option_set_from_local_storage() {
                const mileage_rainfall_daily_option = JSON.parse(localStorage.getItem('mileage_rainfall_daily_option'))
                if (mileage_rainfall_daily_option && Object.keys(mileage_rainfall_daily_option).length !== 0) {
                    this.option_set[0].current_option_value = mileage_rainfall_daily_option.route
                }
            },
        },
	}
</script>

<style>
</style>